import React from "react";
import "./ListCard.css";

export default function ListCard({ icon, title, description }) {
    return (
        <article className="list-card">
            {icon && (
                <div className="list-card__icon">
                    <img src={icon} alt={title} />
                </div>
            )}

            <div className="list-card__content">
                <h3 className="list-card__title">{title}</h3>
                <p className="list-card__desc">{description}</p>
            </div>
        </article>
    );
}
